import { SESSION_ORIGIN_LABEL } from '@/lib/session-origin';
import { Badge } from '@pms-digital/design-system';

/**
 * The mark « prod » (vitrine.md section 8.2, issue #192): a small green outlined
 * pill beside the version on a row of the list, on the head of the parcours and of
 * the conversation, and beside the reference of an interview room.
 *
 * One component for the four places that wear it, so they read the same. Green
 * (the package's bordered `success` badge) like the pointer « latest prod » and
 * the mark « en prod » of the versions: the colour of what the production holds.
 * It says the ORIGIN and nothing else - no status, no version. The marks sit on
 * the envelope, since the package's `Badge` takes no attribute of its own.
 */

export interface OriginMarkProps {
  /** The mark a suite reads this pill by; it differs on each screen. */
  readonly testId: string;
}

export function OriginMark({ testId }: OriginMarkProps) {
  return (
    <span data-testid={testId} data-origin="prod" className="inline-flex align-middle">
      <Badge tone="success" bordered={true} maxWidth="none">
        {SESSION_ORIGIN_LABEL.prod}
      </Badge>
    </span>
  );
}
